import error from './errors';
import validate from './validates';
import menu from './menu';

export default {
  error,
  validate,
  menu,
  app: {
    title: 'Apostilla',
    account: 'Mi cuenta',
    settings: 'Configuración',
    logOut: 'Cerrar sesión'
  },
  login: {
    title: 'Inicia tu sesión',
    user: 'Nombre de usuario',
    password: 'Contraseña',
    rememberMe: 'Recuerdame',
    forgotPass: '¿Se te olvidó tu contraseña?',
    login: 'Ingresar',
    noAccount: '¿No tienes una cuenta?',
    signUp: 'Registrate aquí'
  },
  common: {
    add: 'Agregar',
    required: 'Campo obligatorio',
    cancel: 'Cancelar',
    save: 'Guardar',
    rowsPage: 'Filas por página',
    updateList: 'Actualizar esta lista',
    filters: 'Filtros/búsqueda',
    of: 'de',
    active: 'Activo',
    observation: 'Observar',
    firm: 'Firmar',
    approve: 'Aprobar y Firmar',
    edit: 'Editar',
    status: 'Estado',
    actions: 'Acciones',
    close: 'Cerrar'
  },
  entity: {
    title: 'Entidades',
    add: 'Agregar nueva entidad',
    crud: {
      edit: 'Editar',
      code: 'Código',
      name: 'Nombre',
      acronym: 'Sigla',
      description: 'Descripción',
      status: 'Estado',
      addEnt: 'Agregar entidad',
      editEnt: 'Editar entidad',
      address: 'Dirección',
      email: 'Correo electrónico de atención al cliente',
      phones: 'Teléfono(s)',
      web: 'Página web de la entidad',
      user_ppte: 'Usuario en el sistema PPTE',
      pass_ppte: 'Contraseña en el sistema PPTE'
    }
  },
  applicants: {
    title: 'Solicitantes',
    add: 'Agregar nuevo solicitante',
    crud: {
      edit: 'Editar',
      names: 'Nombres',
      type: 'Tipo',
      first_name: 'Primer Apellido',
      second_name: 'Segundo Apellido',
      email: 'Correo electrónico',
      phones: 'Teléfono(s)',
      birthday: 'Fecha de Nacimiento',
      type_document: 'Tipo de Documento',
      number_document: 'Número de Documento',
      address: 'Dirección',
      enrol: 'Matricula',
      departament: 'Departamento',
      province: 'Provincia',
      municipio: 'Municipio',
      addEnt: 'Agregar Solicitante',
      editEnt: 'Editar Solicitante'
    }
  },
  transact: {
    title: 'Tramites',
    add: 'Agregar nuevo Tramite',
    crud: {
      edit: 'Editar',
      init_date: 'Fecha Inicio',
      end_date: 'Fecha Fin',
      cod_tracking: 'Codigo de Seguimiento',
      solicitante: 'Solicitante',
      status: 'Estado',
      addTran: 'Agregar Tramite',
      editTran: 'Editar Tramite'
    }
  },
  account: {
    title: 'Cuentas',
    add: 'Agregar nueva cuenta',
    select: 'Seleccione una entidad para ver sus cuentas',
    crud: {
      edit: 'Editar',
      accountNumber: 'Nro. de cuenta',
      status: 'Estado',
      entity: 'Entidad',
      addAc: 'Agregar cuenta',
      editAc: 'Editar cuenta'
    }
  },
  user: {
    title: 'Usuarios',
    add: 'Agregar nuevo usuario',
    crud: {
      edit: 'Editar',
      user: 'Usuario',
      userData: 'Datos del usuario',
      entity: 'Entidad',
      role: 'Rol',
      status: 'Estado',
      addUser: 'Agregar usuario',
      editUser: 'Editar usuario',
      fullname: 'Nombre completo',
      email: 'Correo electrónico'
    }
  },
  auxiliar: {
    title: 'Usuarios Auxiliares',
    add: 'Agregar nuevo usuario auxiliar',
    crud: {
      edit: 'Editar',
      user: 'Usuario',
      userData: 'Datos del usuario',
      entity: 'Entidad',
      role: 'Rol',
      status: 'Estado',
      addUser: 'Agregar usuario',
      editUser: 'Editar usuario',
      fullname: 'Nombre completo',
      email: 'Correo electrónico'
    }
  },
  rol: {
    title: 'Roles',
    add: 'Agregar nuevo rol',
    crud: {
      name: 'Nombre',
      description: 'Descripción',
      tipo: 'Tipo',
      editRol: 'Editar Rol',
      addRol: 'Agregar Rol'
    }
  },
  parametro: {
    title: 'Parámetros',
    add: 'Agregar nuevo parámetro',
    preferencias: 'Preferencias',
    crud: {
      name: 'Nombre',
      value: 'Valor',
      label: 'Label',
      description: 'Descripción',
      editParametro: 'Editar Parámetro',
      addParametro: 'Agregar Parámetro'
    }
  },
  documento: {
    title: 'Documentos para los trámites de la entidad',
    add: 'Agregar nuevo documento',
    crud: {
      name: 'Nombre',
      description: 'Descripción',
      status: 'Estado',
      token_ppte: 'Token PPTE',
      codigo_portal: 'Codigo Portal Unico',
      entity: 'Entidad',
      editDocumento: 'Editar Documento',
      addDocumento: 'Agregar Documento'
    }
  },
  module: {
    title: 'Módulos y permisos',
    add: 'Agregar nuevo módulo',
    crud: {
      edit: 'Editar',
      module: 'Módulo padre',
      label: 'Título',
      path: 'Path',
      icon: 'Ícono',
      order: 'Orden',
      status: 'Estado',
      visible: 'Visible',
      submodule: 'Sub módulo',
      section: 'Sección',
      addModule: 'Agregar módulo',
      editModule: 'Editar módulo',
      permissions: 'Permisos'
    }
  },
  tramite_doc: {
    title: 'Documentos de trámite',
    add: 'Agregar nuevo documento para trámite',
    crud: {
      pago: 'Pago',
      pago_entidad: 'Pago entidad',
      pago_cancilleria: 'pago cancilleria',
      cod_seguridad: 'Codigo seguridad',
      nro_apostilla: 'Nro apostilla',
      tramite_cod_seguimiento: 'Código de seguimiento',
      fecha_expedicion: 'Fecha expedicion',
      estado: 'Estado',
      observacion: 'Observación',
      editTramite_doc: 'Editar Tramite_doc',
      addTramite_doc: 'Agregar Tramite_doc',
      docName: 'Nombre documento',
      status: 'Estado',
      documento_nombre: 'Documento',
      nombre_solicitante: 'Solicitante',
      nro_documento: 'NIT/CI',
      fecha_solicitud: 'Fecha solicitud'
    }
  },
  pago: {
    title: 'Pagos',
    add: 'Agregar nuevo pago',
    crud: {
      editPago: 'Editar pago',
      addPago: 'Agregar pago',
      estado: 'Estado',
      id_cpt: 'ID cpt',
      cpt: 'Código de pago',
      tipo: 'Tipo',
      fecha_pago: 'Fecha de pago',
      nro_documento: 'NIT/CI',
      titular_factura: 'Señor(es)'
    }
  },
  log: {
    title: 'Logs del sistema',
    crud: {
      nivel: 'Nivel',
      tipo: 'Tipo',
      mensaje: 'Mensaje',
      referencia: 'Referencia',
      ip: 'IP',
      fecha: 'Fecha de creación',
      id_usuario: 'Usuario'
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/es/messages.js